<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="journal-text" class="icon"></b-icon>
            <span>JOB ORDER</span>
        </div>

        <div class="content">
            <div class="form mb-4">
                <job-list-filter @lookup="filterJobList($event)"></job-list-filter>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>เลขที่</th>
                            <th>ข้อมูลลูกค้า</th>
                            <th>ประเภท</th>
                            <th>ราคา</th>
                            <th class="text-center">สถานะ</th>
                            <th>วันที่เปิดงาน</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in jobList" :key="index">
                            <td><div class="text-center"><router-link :to="item.link" class="btn btn-sm btn-blue text-nowrap">ดูใบงาน</router-link></div></td>
                            <td>{{ item.number }}</td>
                            <td>
                                <template v-if="item.jobType === $Constants.JOB_FORM_STORE">
                                    <span class="main">{{ item.customer }}</span>
                                    <span><b-icon icon="person" class="icon"></b-icon> เลขประจำตัวผู้เสียภาษี: {{ item.taxId }}</span>
                                </template>
                                <template v-else>
                                    <span class="main">{{ item.license }}</span>
                                    <span><b-icon icon="minecart-loaded" class="icon"></b-icon> {{ item.car }}</span>
                                    <span><b-icon icon="person" class="icon"></b-icon> {{ item.customer }}</span>
                                </template>
                            </td>
                            <td>{{ item.orderType }}</td>
                            <td>{{ item.price }}</td>
                            <td class="text-center"><div class="status" :class="item.status.style">{{ item.status.text }}</div></td>
                            <td class="date-time"><b-icon icon="clock"></b-icon> {{ item.openDate }}</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="jobList.length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่มีรายการใบงาน</span>
            </div>

            <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="jobList.length" class="mt-4"></paging>
        </div>
    </div>
</template>

<script>
import MixinJobTable from '@/components/job/JobTable';
import JobListFilter from '@/components/job/ListFilter';
import Helper from '@/resources/Helper';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';
import DBJob from '@/database/Job';
import ModelJobFilter from '@/resources/models/JobFilter';

export default {
    mixins: [ MixinJobTable ],
    components: {
        JobListFilter
    },
    data() {
        return {
            jobList: [],
            jobFilter: ModelJobFilter.data(),
            isLoading: false,
            activePage: 1,
            pageSize: 50
        }
    },
    mounted() {
        this.loadJobList();
    },
    methods: {
        filterJobList(value) {
            this.jobFilter = value;
            this.loadJobList();
        },
        async loadJobList() {
            this.isLoading = true;
            this.jobList = [];
            const result = await DBJob.get();

            if (result.content && result.content.length > 0) {
                // Filter Job Type
                result.content = result.content.filter(x => x.jobType === this.$Constants.JOB_FORM_WALKIN
                                                        || x.jobType === this.$Constants.JOB_FORM_ONLINE
                                                        || x.jobType === this.$Constants.JOB_FORM_FLEET
                                                        || x.jobType === this.$Constants.JOB_FORM_STORE);

                // Filter Result
                result.content = this.mixinsJobTable_FilterResult(result.content);

                // Map and Place into the Object
                this.jobList = this.mapViewData(result.content);
            }

            this.isLoading = false;
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    number: item.number,
                    link: '/job/' + this.mixinsJobTable_GetPathName(item.jobType) + '?o=' + item.number,
                    taxId: this.getTaxId(item),
                    customer: this.getCustomerData(item),
                    orderType: this.mixinsJobTable_GetOrderType(item.jobType),
                    jobType: item.jobType,
                    car: this.getCarData(item),
                    license: this.getLicensePlateData(item),
                    price: Helper.getCommaNumber(this.$AppUtility.calculateOrderTotalPrice(item.order)),
                    status: this.mixinsJobTable_GetStatusDisplay(item.status),
                    openDate: this.$AppUtility.displayTimeFormat(item.openDate),
                });
            });

            return data;
        },
        getTaxId(item) {
            if (item.jobType === this.$Constants.JOB_FORM_STORE) {
                return item.customerStore.taxId;
            } else if (item.jobType === this.$Constants.JOB_FORM_FLEET) {
                return item.fleet.taxId
            } else {
                return '';
            }
        },
        getCustomerData(item) {
            if (item.jobType === this.$Constants.JOB_FORM_STORE) {
                return item.customerStore.name;
            } else if (item.jobType === this.$Constants.JOB_FORM_FLEET) {
                return item.fleet.company;
            } else {
                return [ item.customer.customerFirstName, item.customer.customerLastName ].join(' ');
            }
        },
        getCarData(item) {
            if (item.jobType !== this.$Constants.JOB_FORM_STORE) {
                return [ item.customer.carBrand, item.customer.carModel, item.customer.carYearSerie ].filter(Boolean).join(' ');
            } else {
                return '';
            }
        },
        getLicensePlateData(item) {
            if (item.jobType !== this.$Constants.JOB_FORM_STORE) {
                return [ item.customer.licensePlate, '(' + OptionLicensePlateProvince.service.getValueByKey(item.customer.licensePlateProvince) + ')'].join(' ');
            } else {
                return '';
            }
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/job/JobList.scss';
</style>